<template>
  <v-expansion-panel v-if="apuracao && apuracao.id">
    <v-expansion-panel-header class="headline">
      <div>
        <span>{{ $tc('title.anexos', 1)}}</span>
        <v-tooltip bottom v-if="habilitarUpload">
          <template v-slot:activator="{ on }">
            <v-btn class="ma-0" style="margin-top: -4px !important;" icon v-on="on" @click.stop="$refs.uploadArquivo.open()">
              <v-icon>attach_file</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('title.upload_evidencia') }}</span>
        </v-tooltip>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <list-files
        @ListFiles_ITENS_ALTERADOS="itensAlterados"
        :habilitar-exclusao="habilitarUpload"
        :habilitar-inativacao="habilitarInativacao"
        ref="listFiles"
        :uri="uri"
        v-if="apuracao.id"
        :col-xs="colXs"
        :col-sm="colSm"
        :col-md="colMd"
        :col-lg="colLg"
        @ListFiles__arquivos="possuiArquivos"></list-files>
    </v-expansion-panel-content>
    <upload-file-form
      v-if="habilitarUpload"
      :id="!!apuracao && apuracao.id ? apuracao.id : 100"
      :id-entidade="!!apuracao && apuracao.id ? apuracao.id : 100"
      ref="uploadArquivo"
      :title="$t('label.upload_evidencia')"
      :url="uriUpload"
      :auto-process-queue="!uploadMultiple"
      :upload-multiple="uploadMultiple"
      @UPLOADFILE_SENDING="enviandoArquivo"
      @UPLOADFILE_SENDING_MULTIPLE="enviandoMultiplosArquivos"
      @UPLOADFILE_FILE_ADDED="preencherDescricaoComNomeArquivo"
      @UploadArquivo__success="uploadSucesso"
      @UPLOADFILE_SUCCESS_MULTIPLE="uploadSucessoMultiplo">
      <v-text-field
        v-if="!uploadMultiple"
        v-model="descricaoArquivo"
        :rules="[rules.required]"
        :counter="150"
        maxlength="150"
        :label="`${$t('label.descricao')}*`"
        required
      ></v-text-field>
    </upload-file-form>
  </v-expansion-panel>
</template>

<script>
import { mapGetters } from 'vuex';
import UploadFileForm from '@/shared-components/upload/UploadFileForm';
import ListFiles from '@/shared-components/files/ListFiles';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import basePath from '@/common/functions/api-resource';

export default {
  name: 'ApuracaoAcaoArquivos',
  props: {
    apuracao: Object,
    colXs: {
      type: String,
      default: '6',
    },
    colSm: {
      type: String,
      default: '4',
    },
    colMd: {
      type: String,
      default: '3',
    },
    colLg: {
      type: String,
      default: '2',
    },
  },
  data() {
    return {
      esperar: false,
      descricaoArquivo: null,
      uploadMultiple: true,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  components: {
    UploadFileForm,
    ListFiles,
  },
  computed: {
    ...generateComputed('APU_ACAO', [
      'canEdit',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    uri() {
      const urlUpload = basePath('job', 'arquivo/acao');
      return `${urlUpload}/${this.apuracao.idAcao}/apuracao/${this.apuracao.id}`;
    },
    uriUpload() {
      const urlUpload = basePath('job', 'arquivo/acao');
      if (this.uploadMultiple) {
        return `${urlUpload}/${this.apuracao.idAcao}/apuracao/${this.apuracao.id}/upload-multiplo`;
      }
      return `${urlUpload}/${this.apuracao.idAcao}/apuracao/${this.apuracao.id}/upload`;
    },
    possuiAcessoClienteParaUpload() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'CLIENTE_APU_ACAO_CRUD').length;
    },
    possuiAcessoInativarAnexos() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'INATIVAR_E_VISUALIZAR_ANEXOS_INATIVOS').length;
    },
    habilitarUpload() {
      if (!this.apuracao || !this.apuracao.status) {
        return false;
      }
      return (this.canEdit || this.possuiAcessoClienteParaUpload)
        && ['APURACAO_PREVIA', 'AGUARDANDO_APURACAO', 'EM_ANALISE'].includes(this.apuracao.status);
    },
    habilitarInativacao() {
      if (!this.apuracao || !this.apuracao.status) {
        return false;
      }
      return this.possuiAcessoInativarAnexos
        && ['AGUARDANDO_APROVACAO', 'APROVADO'].includes(this.apuracao.status);
    },
  },
  methods: {
    enviandoArquivo(data, xhr, formData) {
      if (this.uploadMultiple) {
        return;
      }
      const indexUltimoPonto = this.descricaoArquivo.lastIndexOf('.');
      const nomeArquivo = this.descricaoArquivo.substring(0, indexUltimoPonto);
      const extensaoArquivo = this.descricaoArquivo.substring(indexUltimoPonto, this.descricaoArquivo.length);
      this.descricaoArquivo = `${nomeArquivo}-${this.apuracao.idAcao}${extensaoArquivo}`;
      formData.append('descricao', encodeURI(this.descricaoArquivo));
    },
    enviandoMultiplosArquivos(files, xhr, formData) {
      files.forEach((file, index) => {
        const indexUltimoPonto = file.name.lastIndexOf('.');
        const nomeArquivo = file.name.substring(0, indexUltimoPonto);
        const extensaoArquivo = file.name.substring(indexUltimoPonto);

        const novaDescricao = `${nomeArquivo}-${this.apuracao.idAcao}${extensaoArquivo}`;
        formData.append(`descricoes[${index}]`, encodeURI(novaDescricao));
      });
    },
    itensAlterados(payload) {
      this.$emit('ApuracaoAcaoArquivos_itensAlterados', payload);
    },
    preencherDescricaoComNomeArquivo(file) {
      if (this.uploadMultiple) {
        return;
      }

      this.descricaoArquivo = file.name;
    },
    uploadSucesso() {
      if (this.uploadMultiple) {
        return;
      }

      if (this.$refs.listFiles) {
        setTimeout(() => this.$refs.listFiles.refresh(), 1E3);
      }
      this.$toast(this.$tc('label.upload_arquivo_sucesso', 1));
      this.$emit('ApuracaoAcaoArquivos_uploadSucesso');
    },
    uploadSucessoMultiplo() {
      setTimeout(() => this.$refs.listFiles.refresh(), 1E3);
      this.$toast(this.$tc('label.upload_arquivo_sucesso', 2));
    },
    arquivoRemovido() {
      if (this.$refs.listFiles.files.length === 1) {
        this.$emit('ApuracaoAcaoArquivos_arquivosRemovidos');
      }
    },
    possuiArquivos(files) {
      this.$emit('ApuracaoAcaoArquivos_possuiArquivos', files);
    },
  },
  watch: {
    acao() {
      if (this.$refs.listFiles) {
        if (!this.esperar) {
          this.esperar = true;
          setTimeout(() => {
            if (this.$refs.listFiles) {
              this.$refs.listFiles.refresh();
            }
            this.esperar = false;
          }, 2E2);
        }
      }
    },
  },
};
</script>
